import type { ActionFunctionArgs } from '@remix-run/node';
import { ServerErrorResponse } from '@modules/root/graphql/responses';
import { type ItemType } from '@modules-rocco/mood-board/types/mood-board-api-types';
import { addItemsToMoodBoard } from '@modules-rocco/mood-board/api/add-items-to-mood-board.server';

/** Form data shape for adding items to a board. */
export interface AddItemsToBoardFormData {
    boardId: number;
    itemsType: ItemType;
    itemIds: number[];
}

export const ACTION_ADD_ITEMS_TO_MOOD_BOARD =
    '/actions/add-items-to-mood-board';

export const action = async ({ request, context }: ActionFunctionArgs) => {
    const formData = await request.formData();
    const formObj: AddItemsToBoardFormData = {
        boardId: Number(formData.get('boardId')),
        itemsType: formData.get('itemsType') as ItemType,
        itemIds: formData.getAll('itemIds[]').map(Number),
    };

    if (formObj.boardId < 0) {
        // '0' is used for guest design boards
        return new ServerErrorResponse('Board ID is required');
    }

    if (!formObj.itemsType) {
        return new ServerErrorResponse('Items type is required');
    }

    if (!formObj.itemIds) {
        return new ServerErrorResponse('Item IDs are required');
    }

    return await addItemsToMoodBoard(formObj, context);
};
